import React, { useContext, useState, useEffect } from 'react';
import { AppContext } from '../App';
import { callApi, getInlineLoader, isAlphanumeric, resolveOrientation } from '../Helpers';
import { IoEnterOutline } from 'react-icons/io5';
import TopBar from '../components/TopBar';
import CommunityChat from '../views/CommunityChat';

export default function View(props) {
  const appContext = useContext(AppContext);
  const requiredOrientation = "portrait";
  const [ stickyChatRooms, setStickyChatRooms ] = useState([]);
  const [ normalChatRooms, setNormalChatRooms ] = useState([]);
  const [ ready, setReady ] = useState(false);
  const [ loading, setLoading ] = useState(false);

  

  return (
    <>
      <TopBar title="Community Chat"/>
      <div className="FullPane" data-support-top-bar={true}>
        <CommunityChat/>
      </div>
    </>
  )
}
